import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Textarea } from "./ui/textarea";
import { api, todayISO } from "../lib/api";
import { toast } from "../hooks/use-toast";

export default function AddStudyModal({ open, onOpenChange, disciplines, onCreated }) {
  const [form, setForm] = React.useState({
    discipline_id: "",
    topic: "",
    date: todayISO(),
    hours: 0,
    minutes: 0,
    correct: 0,
    wrong: 0,
    questions: 0,
    notes: "",
  });
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    if (open) setForm((f) => ({ ...f, date: todayISO() }));
  }, [open]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target?.value ?? e }));

  const submit = async () => {
    if (!form.discipline_id) {
      toast({ title: "Selecione uma disciplina" });
      return;
    }
    setSaving(true);
    try {
      const duration = Number(form.hours) * 60 + Number(form.minutes);
      const q = Number(form.questions) || Number(form.correct) + Number(form.wrong);
      await api.post("/study-sessions", {
        discipline_id: form.discipline_id,
        topic: form.topic || null,
        date: form.date,
        duration_minutes: duration,
        correct: Number(form.correct) || 0,
        wrong: Number(form.wrong) || 0,
        questions: q,
        notes: form.notes || null,
      });
      toast({ title: "Estudo registrado!" });
      onCreated && onCreated();
      onOpenChange(false);
      setForm({ discipline_id: "", topic: "", date: todayISO(), hours: 0, minutes: 0, correct: 0, wrong: 0, questions: 0, notes: "" });
    } catch (e) {
      toast({ title: "Erro ao salvar", description: e.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Adicionar Estudo</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Disciplina</Label>
            <Select value={form.discipline_id} onValueChange={(v) => setForm((f) => ({ ...f, discipline_id: v }))}>
              <SelectTrigger><SelectValue placeholder="Selecione uma disciplina" /></SelectTrigger>
              <SelectContent>
                {disciplines.map((d) => (
                  <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Tópico (opcional)</Label>
            <Input value={form.topic} onChange={set("topic")} placeholder="Ex: Princípios constitucionais" />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <Label>Data</Label>
              <Input type="date" value={form.date} onChange={set("date")} />
            </div>
            <div>
              <Label>Horas</Label>
              <Input type="number" min="0" value={form.hours} onChange={set("hours")} />
            </div>
            <div>
              <Label>Minutos</Label>
              <Input type="number" min="0" max="59" value={form.minutes} onChange={set("minutes")} />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <Label>Acertos</Label>
              <Input type="number" min="0" value={form.correct} onChange={set("correct")} />
            </div>
            <div>
              <Label>Erros</Label>
              <Input type="number" min="0" value={form.wrong} onChange={set("wrong")} />
            </div>
            <div>
              <Label>Questões</Label>
              <Input type="number" min="0" value={form.questions} onChange={set("questions")} />
            </div>
          </div>
          <div>
            <Label>Anotações</Label>
            <Textarea rows={3} value={form.notes} onChange={set("notes")} placeholder="O que você estudou hoje?" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={submit} disabled={saving} className="bg-tiffany-500 hover:bg-tiffany-600 text-white">
            {saving ? "Salvando..." : "Salvar estudo"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
